export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-6 p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-bold text-background-50 font-heading">
                移动端入口
              </h2>
              <p className="mt-2 text-sm md:text-base text-background-50/80 leading-relaxed">
                随时随地畅享吃瓜乐趣，51黑料吃瓜网移动端入口专为手机浏览优化。扫码访问或收藏本页面，黑料吃瓜网址一键直达，最新爆料不再错过。
              </p>
              <div className="mt-5 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-semibold text-sm rounded-full cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  扫码访问移动端
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-600 text-background-50 font-medium text-sm rounded-full border border-background-50/30 cursor-pointer hover:bg-primary-500 transition-colors whitespace-nowrap">
                  <i className="ri-bookmark-line"></i>
                  收藏本站入口
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 bg-background-50 rounded-2xl flex items-center justify-center">
              <div className="text-center">
                <i className="ri-qr-code-line text-5xl md:text-6xl text-primary-500"></i>
                <p className="mt-1 text-xs text-primary-400">扫码访问</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}